var map = {
	"./date-iso.d": 21905,
	"./date-iso.d.ts": 21905,
	"./import-png.d": 30283,
	"./import-png.d.ts": 30283,
	"./import-svg.d": 80365,
	"./import-svg.d.ts": 80365,
	"src/javascript/typings/date-iso.d": 21905,
	"src/javascript/typings/date-iso.d.ts": 21905,
	"src/javascript/typings/import-png.d": 30283,
	"src/javascript/typings/import-png.d.ts": 30283,
	"src/javascript/typings/import-svg.d": 80365,
	"src/javascript/typings/import-svg.d.ts": 80365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79057;